import { Statistic, Typography } from 'antd'
import type { ReactNode } from 'react'

export interface CardState<T> {
  data?: T
  loading: boolean
  error: boolean
}

/** A failed query shows its error, never stale data. */
export function cardState<T>(query: {
  data?: T
  isPending: boolean
  isError: boolean
}): CardState<T> {
  return {
    data: query.isError ? undefined : query.data,
    loading: query.isPending,
    error: query.isError,
  }
}

export function ResourceStatistic<T>({
  title,
  state,
  errorText,
  value,
  suffix,
  prefix,
}: {
  title: string
  state: CardState<T>
  errorText: string
  value: (data: T) => string | number
  suffix?: (data: T) => string
  prefix: ReactNode
}) {
  const { data, loading, error } = state
  return (
    <Statistic
      title={title}
      value={data === undefined ? undefined : value(data)}
      suffix={data === undefined || !suffix ? undefined : suffix(data)}
      prefix={error ? undefined : prefix}
      loading={loading}
      valueRender={
        error
          ? () => <Typography.Text type="danger">{errorText}</Typography.Text>
          : undefined
      }
    />
  )
}
